import React, { useCallback, useState, useEffect } from 'react';
import { Button, Input } from '@stats/playbook-components';
import styled from 'styled-components';

const ClearButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  position: absolute;
  right: 30px;
  top: 50%;
  transform: translateY(-50%);
  color: #666;
  font-size: 16px;
  &:hover {
    color: #333;
  }
`;

const InputWrapper = styled.div`
  position: relative;
  display: inline-block;
  margin-right: 15px;
  margin-bottom: 20px;
`;

const FiltersContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
`;

const ButtonsContainer = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
`;

type FilterProps = {
  filename: string;
  type: string;
  league: string;
  onSubmit: Function;
}

const DeliveryHistoryFilters: React.FC<FilterProps> = (props) => {
  const [fileText, setFileText] = useState(props.filename);
  const [typeText, setTypeText] = useState(props.type);
  const [leagueText, setLeagueText] = useState(props.league);

  // Update local state when props change
  useEffect(() => {
    setFileText(props.filename);
    setTypeText(props.type);
    setLeagueText(props.league);
  }, [props.filename, props.type, props.league]);

  const onFilenameChange = useCallback((e: React.FormEvent<HTMLInputElement>) => {
    setFileText(e.currentTarget.value);
  }, []);

  const onFileTypeChange = useCallback((e: React.FormEvent<HTMLInputElement>) => {
    setTypeText(e.currentTarget.value);
  }, []);

  const onLeagueChange = useCallback((e: React.FormEvent<HTMLInputElement>) => {
    setLeagueText(e.currentTarget.value);
  }, []);

  const clearFilename = useCallback(() => {
    setFileText('');
  }, []);

  const clearFileType = useCallback(() => {
    setTypeText('');
  }, []);

  const clearLeague = useCallback(() => {
    setLeagueText('');
  }, []);

  const clearAllFilters = useCallback(() => {
    setFileText('');
    setTypeText('');
    setLeagueText('');
  }, []);

  const onClick = useCallback(() => {
    props.onSubmit({
      file: fileText.toUpperCase(),
      type: typeText.toLowerCase(),
      league: leagueText.toLowerCase()
    });
  }, [fileText, typeText, leagueText, props]);


  return (
    <>
      <FiltersContainer>
        <InputWrapper>
          <Input
            value={fileText}
            label='Filename'
            className={'filter'}
            onChange={onFilenameChange}
            placeholder="Enter filename"
          />
          {fileText && <ClearButton onClick={clearFilename}>×</ClearButton>}
        </InputWrapper>

        <InputWrapper>
          <Input
            value={typeText}
            label='File Type'
            className={'filter'}
            onChange={onFileTypeChange}
            placeholder="Enter file type"
          />
          {typeText && <ClearButton onClick={clearFileType}>×</ClearButton>}
        </InputWrapper>

        <InputWrapper>
          <Input
            value={leagueText}
            label='League'
            className={'filter'}
            onChange={onLeagueChange}
            placeholder="Enter league"
          />
          {leagueText && <ClearButton onClick={clearLeague}>×</ClearButton>}
        </InputWrapper>

        <ButtonsContainer>
          <Button variant="primary-black" onClick={onClick}>
            Apply Filters
          </Button>
          {(fileText || typeText || leagueText) && (
            <Button variant="secondary-dark" onClick={clearAllFilters}>
              Clear All
            </Button>
          )}
        </ButtonsContainer>
      </FiltersContainer>
    </>
  );
}

export default DeliveryHistoryFilters;
